import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ButtonsContainer, BackButton, ScheduleButton } from './ActionButtonsStyles';
import Modal, { ConsultationForm } from './Modal';

const ActionButtons = () => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  // Função para abrir o modal
  const openModal = () => {
    setShowModal(true);
  };
  
  // Função para fechar o modal
  const closeModal = () => {
    setShowModal(false);
  };
  
  // Função para lidar com o envio do formulário
  const handleFormSubmit = async (formData) => {
    try {
      setLoading(true);
      console.log('Dados do agendamento:', formData);
      
      // O salvamento já foi feito pelo webhook, não precisamos salvar novamente
      // Apenas fechamos o modal e redirecionamos
      
      // Fechamos o modal
      closeModal();
      
      // Redirecionamos para a página de agradecimento
      navigate('/ty');
    } catch (error) {
      console.error('Erro ao processar agendamento:', error);
      alert('Ocorreu um erro ao agendar sua consultoria. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };
  
  // Renderiza as partículas de dados para o botão de agendamento
  const renderDataParticles = () => {
    const particles = [];
    for (let i = 0; i < 8; i++) {
      const top = `${Math.random() * 100}%`;
      const left = `${Math.random() * 100}%`;
      const delay = `${Math.random() * 2}s`;
      const size = `${Math.random() * 2 + 2}px`;
      
      particles.push(
        <div 
          key={i}
          className="data-particle"
          style={{
            top,
            left,
            width: size,
            height: size,
            animationDelay: delay
          }}
        />
      );
    }
    return particles;
  };
  
  return (
    <ButtonsContainer>
      <ScheduleButton onClick={openModal}>
        <svg 
          className="calendar-icon" 
          width="22" 
          height="22" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect 
            x="3" 
            y="4" 
            width="18" 
            height="18" 
            rx="2" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M16 2V6" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M8 2V6" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M3 10H21" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <circle cx="8" cy="14" r="1" fill="currentColor" />
          <circle cx="12" cy="14" r="1" fill="currentColor" />
          <circle cx="16" cy="14" r="1" fill="currentColor" />
          <circle cx="8" cy="18" r="1" fill="currentColor" />
          <circle cx="12" cy="18" r="1" fill="currentColor" />
          <circle cx="16" cy="18" r="1" fill="currentColor" />
        </svg>
        Agendar Consultoria
        {renderDataParticles()}
      </ScheduleButton>
      
      <Link to="/">
        <BackButton>
          <svg 
            className="arrow-icon" 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M19 12H5" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
            <path 
              d="M12 19L5 12L12 5" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
          Voltar para Teste
        </BackButton>
      </Link>
      
      {/* Modal de Agendamento */}
      <Modal 
        isOpen={showModal} 
        onClose={closeModal} 
        title="Agendar Consultoria"
      >
        <ConsultationForm onSubmit={handleFormSubmit} isSubmitting={loading} />
      </Modal>
    </ButtonsContainer>
  );
};

export default ActionButtons;
